// base state machine
const stateMachine = require('./stateMachine');

// DEFINE INTERACTION NAME
const interactionName = 'interaction--add-to-bag';

// CONSTANT STATES FOR THE INTERACTION
const STATE_ADD_TO_BAG = {
  DISABLED: 'state-add-to-bag-disabled',
  ENABLED: 'state-add-to-bag-enabled',
  BUSY: 'state-add-to-bag-busy',
  ADDED: 'state-add-to-bag-added',
};

const times = new WeakMap();

// Available states, interaction definition
const states = {
  [STATE_ADD_TO_BAG.DISABLED]: {
    allowed: [STATE_ADD_TO_BAG.ENABLED],
    enter() {},
  },
  [STATE_ADD_TO_BAG.ENABLED]: {
    allowed: [STATE_ADD_TO_BAG.DISABLED, STATE_ADD_TO_BAG.BUSY],
    enter() {},
  },
  [STATE_ADD_TO_BAG.BUSY]: {
    allowed: [
      STATE_ADD_TO_BAG.ADDED,
      STATE_ADD_TO_BAG.ENABLED,
      STATE_ADD_TO_BAG.DISABLED,
    ],
    enter(target) {
      times.set(target, Date.now());
    },

    async exit(target) {
      const elapsedTime = Date.now() - times.get(target);
      const minWaitTime = 600;

      if (elapsedTime < minWaitTime) {
        await new Promise((resolve) => {
          setTimeout(
            () => {
              resolve();
            },
            Math.abs(minWaitTime - elapsedTime)
          );
        });
      }
    },
  },
  [STATE_ADD_TO_BAG.ADDED]: {
    allowed: [STATE_ADD_TO_BAG.DISABLED, STATE_ADD_TO_BAG.ENABLED],
    enter() {
      // SET BUTTON TO DISABLED after 2 seconds
    },
  },
};

function init(item) {
  stateMachine.init(item, interactionName, states);
}

function destroy() {
  stateMachine.destroy();
}

module.exports = {
  interactionName,
  STATE_ADD_TO_BAG,
  init,
  destroy,
};
